<template>
  <div class="d-flex d-flex-center toolbar">
    <div class="flex-grow-0">
      <span
        v-if="getGameConsole === 'default'"
        class="context-button"
        @click="changeLiveMode('preview')"
        :class="[this.getLiveMode == 'preview' ? 'active-context' : '']"
        :title="$t('sport')"
        >{{ $t('sportcontext') }}
      </span>
      <span
        v-if="getGameConsole === 'default' && testResult()"
        class="context-button"
        @click="changeLiveMode('result')"
        :class="[this.getLiveMode == 'result' ? 'active-context' : '']"
        :title="$t('result')"
        >{{ $t('result') }}
      </span>
      <span
        v-if="getCashier || getType == 4"
        class="context-button"
        @click="changeLiveMode('qBet')"
        :class="[this.getLiveMode == 'qBet' ? 'active-context' : '']"
        :title="$t('qbet')"
      >
        {{ $t('qbet') }}
      </span>
      <span
        v-if="getCashier || getType == 4"
        class="context-button"
        @click="changeLiveMode('printodds')"
        :class="[this.getLiveMode == 'printodds' ? 'active-context' : '']"
        :title="$t('printodds')"
      >
        {{ $t('printodds') }}
      </span>
      <span
        v-if="getGameConsole === 'default'"
        class="context-button"
        @click="changeLiveMode('detail')"
        :class="[this.getLiveMode == 'detail' ? 'active-context' : '']"
        :title="$t('live')"
      >
        {{ $t('live') }}
      </span>

      <span
        v-if="
          (getCashier === true || getType === '4') &&
          getGameConsole === 'marketview'
        "
        class="context-button"
        @click="changeLiveMode('preview')"
        :class="[this.getLiveMode == 'preview' ? 'active-context' : '']"
        :title="$t('sport')"
      >
        {{ $t('sportcontext') }}
      </span>

      <span
        v-if="
          (getCashier === true || getType === '4') &&
          getGameConsole === 'marketview'
        "
        class="context-button"
        @click="changeLiveMode('detail')"
        :class="[this.getLiveMode == 'detail' ? 'active-context' : '']"
        :title="$t('live')"
      >
        {{ $t('live') }}
      </span>

      <!--<div class="item my-bets" :class="(getQbet)? 'active' : 'deactivated'"  @click="switchQbetSection(true)">
              {{$t('qbet')}}
            </div>
            <div v-if="isPrintOddsVisible" class="item my-bets" :class="(getPrint)? 'active' : 'deactivated'"  @click="switchPrintSection(true)">
              {{$t('printodds')}}
            </div>-->
    </div>
    <!-- Settings -->
    <div class="flex-grow-1 flex-end text-right">
      <!--      <v-menu offset-y min-width="150" max-width="250" :close-on-content-click="false" dark>-->
      <!--        <template v-slot:activator="{ on, attrs }">-->
      <!--          <v-btn color="grey" dark v-bind="attrs" v-on="on" rounded outlined class="text-capitalize bold">-->
      <!--            <v-icon left dark color="#fed430">mdi-star</v-icon>-->
      <!--            {{ $t('favourites') }}-->
      <!--            <v-icon right dark>mdi-chevron-down</v-icon>-->
      <!--          </v-btn>-->
      <!--        </template>-->
      <!--        <v-container dark fluid class="bg-dark">-->

      <!--        </v-container>-->
      <!--      </v-menu>-->
      <span class="time-text">
        {{ this.nowTime }}
      </span>
      <!--            <toolbar-settings></toolbar-settings>-->
    </div>
    <!-- End Settings -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SwitchDarkMode from '@/components/left_widgets/SwitchDarkMode'
import ToolbarSettings from './ToolbarSettings'

export default {
  name: 'Toolbar',
  components: { ToolbarSettings, SwitchDarkMode },
  data: () => ({
    // oddsType: 'decimal',
    nowTime: '',
  }),
  created() {
    //setInterval(this.getNow, 1000);
  },
  mounted() {},
  beforeDestroy() {},
  computed: {
    ...mapGetters({
      getSettings: 'cart/getSettings',
      getLoading: 'cart/getLoading',
      getLiveMode: 'odds/getLiveMode',
      getCountLive: 'odds/getCountLive',
      getOddsVariation: 'cart/getOddsVariation',
      getType: 'user/getType',
      getQbet: 'tree/getQbet',
      getPrint: 'tree/getPrint',
      getCashier: 'user/getCashier',
      getResults: 'settings/getResults',
      getOddsType: 'odds/getOddsType',
      getGameConsole: 'settings/getGameConsole',
    }),
  },
  methods: {
    ...mapActions({
      setLiveMode: 'odds/setLiveMode',
      setStatusQbet: 'tree/setStatusQbet',
    }),
    changeLiveMode(mode) {
      this.setStatusQbet(false)
      this.setLiveMode({ mode: mode })
    },
    testResult() {
      let user = 2
      //console.log("CASHIER",this.getCashier)
      if (this.getType) {
        user = +this.getType
      }

      if (this.getCashier) {
        user = 100
      }

      /*console.log("SI O NO",this.getResults.includes(user))

                console.log("TYYPE",+this.getType)
                console.log("RESULT",this.getResults)*/
      if (this.getResults.includes(user)) {
        return true
      } else {
        return false
      }
      /*console.log("user",user)*/
    },
    getNow: function () {
      const today = new Date()
      const gmt = today.getTimezoneOffset() / -60
      let locale = ''
      if (gmt > 0) {
        locale = ' (GMT +' + gmt + ')'
      } else {
        locale = ' (GMT ' + gmt + ')'
      }
      this.nowTime = today.toLocaleTimeString() + locale
    },
  },
  // watch: {
  //   oddsType(newVal, oldVal) {
  //     this.$store.commit("odds/SET_ODDS_TYPE", newVal);
  //     this.$store.commit("cart/SET_ODDS_VARIATION", newVal);
  //   }
  // },
}
</script>

<style scoped></style>
